import {EnvironmentProviders, inject, provideAppInitializer, Provider, provideZonelessChangeDetection} from '@angular/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ConnectionInterceptor} from '../http-interceptors/connection.interceptor';
import {CacheBustingInterceptor} from '../http-interceptors/cache-busting-interceptor';
import {ApiInterceptor} from '../http-interceptors/api.interceptor';
import {AuthInterceptor} from '../http-interceptors/auth-interceptor';
import {LanguageService} from '../services/language/language.service';
import {LOCAL_FILE_SERVICE} from '../services/local-file/local-file.service';
import {appInitializerFactory, platformDependentClass} from '../util/ng-module-utils.util';
import {WebLocalFileService} from '../services/local-file/web/web-local-file.service';
import {AndroidLocalFileService} from '../services/local-file/android/android-local-file.service';
import {IosLocalFileService} from '../services/local-file/mobile/ios-local-file.service';
import {ElectronMacLocalFileService} from '../services/local-file/electron-mac/electron-mac-local-file.service';
import {ElectronWindowsLocalFileService} from '../services/local-file/electron-windows/electron-windows-local-file.service';
import {TranslateService} from '@ngx-translate/core';
import {provideRouter, Router, withRouterConfig} from '@angular/router';
import {BrowserQuery} from '../queries/browser.query';
import {AppService} from '../services/app/app.service';
import {TraceService} from '@sentry/angular';
import {CheckedOutDocumentService} from '../services/checked-out-document/checked-out-document.service';
import {APP_ROUTES} from '../app.routes';
import {AZURE_SERVICE} from '../services/azure/azure.service';
import {AzureWebService} from '../services/azure/azure.web.service';
import {AzureElectronService} from '../services/azure/azure.electron.service';
import {AzureCapacitorService} from '../services/azure/azure.capacitor.service';
import {NavigationService} from '../services/navigation/navigation.service';
import {AuthQuery} from '../queries/auth.query';
import {UserQuery} from '../queries/user.query';
import {SystemInfoService} from '../services/system-info/system-info.service';

export const DEFAULT_PROVIDERS: Array<Provider | EnvironmentProviders> = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ConnectionInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: CacheBustingInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    },
    {
        provide: LOCAL_FILE_SERVICE,
        useClass: platformDependentClass({
            web: WebLocalFileService,
            android: AndroidLocalFileService,
            ios: IosLocalFileService,
            electronMac: ElectronMacLocalFileService,
            electronWindows: ElectronWindowsLocalFileService,
        }),
    },
    {
        provide: AZURE_SERVICE,
        useClass: platformDependentClass({
            web: AzureWebService,
            android: AzureCapacitorService,
            ios: AzureCapacitorService,
            electronMac: AzureElectronService,
            electronWindows: AzureElectronService,
        }),
    },
    {
        provide: 'Window',
        useValue: window
    },
    provideZonelessChangeDetection(),
    provideAppInitializer(async () => appInitializerFactory(
        inject(TranslateService),
        inject(Router),
        inject(LanguageService),
        inject(BrowserQuery),
        inject(AppService),
        inject(NavigationService),
        inject(AuthQuery),
        inject(UserQuery),
        inject(TraceService),
        inject(CheckedOutDocumentService),
        inject(SystemInfoService))),
    provideRouter(APP_ROUTES, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
];
